import React from "react";
import { Box, IconButton, Typography, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CardSettings = ({
  index,
  mode,
  versusSettings,
  versusPackType,
  handleDeleteCard,
  setVersusSettings,
}) => {
  const handleInputChange = (field, value) => {
    const newSettings = { ...versusSettings };
    const packSettingIndex = newSettings.packSettings.findIndex(
      (p) => +p.packType === +versusPackType
    );
    newSettings.packSettings[packSettingIndex].probability[index][field] =
      Number(value);
    setVersusSettings(newSettings);
  };

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        border: "1px solid #eee",
        borderRadius: 1,
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="subtitle1">Card {index + 1}</Typography>
        <IconButton
          size="small"
          onClick={() => handleDeleteCard(index)}
          sx={{ p: 0.5 }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
        }}
      >
        <TextField
          label="Base %"
          type="number"
          value={mode.Base}
          onChange={(e) => handleInputChange("Base", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
        />
        <TextField
          label="Gold %"
          type="number"
          value={mode.Gold}
          onChange={(e) => handleInputChange("Gold", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
        />
        <TextField
          label="Purple %"
          type="number"
          value={mode.Purple}
          onChange={(e) => handleInputChange("Purple", e.target.value)}
          fullWidth
          variant="outlined"
          size="small"
        />
      </Box>
    </Box>
  );
};

export default CardSettings;
